'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bluebird = require('bluebird');

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _AutoDiscoveryUtils = require('../../../utils/AutoDiscoveryUtils');

var _AutoDiscoveryUtils2 = _interopRequireDefault(_AutoDiscoveryUtils);

var _SdkConfig = require('../../../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

var _ServerTypeSelector = require('../../views/auth/ServerTypeSelector');

var ServerType = _interopRequireWildcard(_ServerTypeSelector);

var _ServerConfig2 = require('./ServerConfig');

var _ServerConfig3 = _interopRequireDefault(_ServerConfig2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var MODULAR_URL = 'https://modular.im/?utm_source=riot-web&utm_medium=web&utm_campaign=riot-web-authentication';

// TODO: TravisR - Can this extend ServerConfig for most things?

/*
 * Configure the Modular server name.
 *
 * This is a variant of ServerConfig with only the HS field and different body
 * text that is specific to the Modular case.
 */

var ModularServerConfig = function (_ServerConfig) {
    (0, _inherits3.default)(ModularServerConfig, _ServerConfig);

    function ModularServerConfig() {
        (0, _classCallCheck3.default)(this, ModularServerConfig);
        return (0, _possibleConstructorReturn3.default)(this, (ModularServerConfig.__proto__ || (0, _getPrototypeOf2.default)(ModularServerConfig)).apply(this, arguments));
    }

    (0, _createClass3.default)(ModularServerConfig, [{
        key: 'validateAndApplyServer',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(hsUrl, isUrl) {
                var defaultConfig, result, message;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // Always try and use the defaults first
                                defaultConfig = _SdkConfig2.default.get()["validated_server_config"];

                                if (!(defaultConfig.hsUrl === hsUrl && defaultConfig.isUrl === isUrl)) {
                                    _context.next = 5;
                                    break;
                                }

                                this.setState({ busy: false, errorText: "" });
                                this.props.onServerConfigChange(defaultConfig);
                                return _context.abrupt('return', defaultConfig);

                            case 5:

                                this.setState({
                                    hsUrl: hsUrl,
                                    isUrl: isUrl,
                                    busy: true,
                                    errorText: ""
                                });

                                _context.prev = 6;
                                _context.next = 9;
                                return (0, _bluebird.resolve)(_AutoDiscoveryUtils2.default.validateServerConfigWithStaticUrls(hsUrl, isUrl));

                            case 9:
                                result = _context.sent;

                                this.setState({ busy: false, errorText: "" });
                                this.props.onServerConfigChange(result);
                                return _context.abrupt('return', result);

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](6);

                                console.error(_context.t0);
                                message = (0, _languageHandler._t)("Unable to validate homeserver/identity server");

                                if (_context.t0.translatedMessage) {
                                    message = _context.t0.translatedMessage;
                                }
                                this.setState({
                                    busy: false,
                                    errorText: message
                                });

                                return _context.abrupt('return', null);

                            case 22:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[6, 15]]);
            }));

            function validateAndApplyServer(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return validateAndApplyServer;
        }()
    }, {
        key: 'validateServer',
        value: function () {
            var _ref2 = (0, _bluebird.method)(function () {
                // TODO: Do we want to support .well-known lookups here?
                // If for some reason someone enters "matrix.org" for a URL, we could do a lookup to
                // find their homeserver without demanding they use "https://matrix.org"
                return this.validateAndApplyServer(this.state.hsUrl, ServerType.TYPES.PREMIUM.identityServerUrl);
            });

            function validateServer() {
                return _ref2.apply(this, arguments);
            }

            return validateServer;
        }()
    }, {
        key: 'render',
        value: function render() {
            var Field = _index2.default.getComponent('elements.Field');
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');

            var submitButton = this.props.submitText ? _react2.default.createElement(
                AccessibleButton,
                {
                    element: 'button',
                    type: 'submit',
                    className: this.props.submitClass,
                    onClick: this.onSubmit,
                    disabled: this.state.busy },
                this.props.submitText
            ) : null;

            return _react2.default.createElement(
                'div',
                { className: 'mx_ServerConfig' },
                _react2.default.createElement(
                    'h3',
                    null,
                    (0, _languageHandler._t)("Your Modular server")
                ),
                (0, _languageHandler._t)("Enter the location of your Modular homeserver. It may use your own " + "domain name or be a subdomain of <a>modular.im</a>.", {}, {
                    a: function a(sub) {
                        return _react2.default.createElement(
                            'a',
                            { href: MODULAR_URL, target: '_blank', rel: 'noopener' },
                            sub
                        );
                    }
                }),
                _react2.default.createElement(
                    'form',
                    { onSubmit: this.onSubmit, autoComplete: 'off', action: null },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_ServerConfig_fields' },
                        _react2.default.createElement(Field, { id: 'mx_ServerConfig_hsUrl',
                            label: (0, _languageHandler._t)("Server Name"),
                            placeholder: this.props.serverConfig.hsUrl,
                            value: this.state.hsUrl,
                            onBlur: this.onHomeserverBlur,
                            onChange: this.onHomeserverChange
                        })
                    ),
                    submitButton
                )
            );
        }
    }]);
    return ModularServerConfig;
}(_ServerConfig3.default);

ModularServerConfig.propTypes = _ServerConfig3.default.propTypes;
exports.default = ModularServerConfig;
module.exports = exports['default'];
//# sourceMappingURL=ModularServerConfig.js.map